module.exports = __webpack_public_path__ + "static/media/banner_7mojos-half.00a59afa.png";